export const STORE_PURCHASE_USER_ID = 'STORE_PURCHASE_USER_ID';

export const storePurchaseUserId = ({ userId }) => ({
  type: STORE_PURCHASE_USER_ID,
  payload: {
    userId
  }
});
